(()=>{
  const init=()=>{
    const root=document.querySelector('[data-sidekick-entry]');
    document.documentElement.classList.remove('ns-sk-pending');
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    const query=new URLSearchParams(location.search),force=query.get('landing')==='1';
    let entered=false;
    try{entered=sessionStorage.getItem('ns-sidekick-entered')==='1'}catch{}
    if(query.get('enter')==='1'||(entered&&!force&&!window.Shopify?.designMode))return;
    const device=root.querySelector('[data-sk-device]'),lid=root.querySelector('[data-sk-lid]'),unlock=root.querySelector('[data-sk-open]'),trackball=root.querySelector('[data-sk-trackball]'),screen=root.querySelector('[data-sk-interface]'),help=root.querySelector('[data-sk-help]'),announcement=root.querySelector('[data-sk-announcement]'),options=[...root.querySelectorAll('[data-sk-option]')];
    let opened=false,index=0,lidDrag=null,ballDrag=null,suppressLidClick=false,suppressBallClick=false,wheelTime=0,leaving=false;
    const previousFocus=document.activeElement,blocked=[];
    root.hidden=false;
    document.documentElement.classList.add('ns-sk-active');
    for(const node of document.body.children){if(!node.contains(root)&&!['SCRIPT','STYLE','LINK'].includes(node.tagName)){blocked.push([node,node.inert]);node.inert=true}}
    const positionCharacter=()=>{const selected=options[index],character=root.querySelector('.ns-sk-character');if(!character||!selected)return;character.style.left=`${selected.offsetLeft+selected.offsetWidth-screen.clientWidth*.025}px`;character.style.right='auto'};
    const show=()=>{
      options.forEach((option,i)=>{
        let offset=(i-index+options.length)%options.length;
        if(offset>options.length/2)offset-=options.length;
        const visible=Math.abs(offset)<=2,angle=offset*Math.PI/4.6;
        option.style.setProperty('--menu-x',`${4+Math.cos(angle)*7}%`);
        option.style.setProperty('--menu-y',`${50+Math.sin(angle)*43}%`);
        option.style.setProperty('--menu-scale',offset===0?'1':'.73');
        option.style.setProperty('--menu-opacity',visible?(offset===0?'1':'.65'):'0');
        option.dataset.visible=String(visible);
        option.classList.toggle('is-selected',offset===0);
        option.tabIndex=offset===0?0:-1;
        option.setAttribute('aria-hidden',String(!visible));
        if(offset===0)option.setAttribute('aria-current','true');else option.removeAttribute('aria-current');
      });
      root.querySelector('[data-sk-language]').textContent=options[index].dataset.language;
      root.querySelector('[data-sk-counter]').textContent=`${String(index+1).padStart(2,'0')} / ${String(options.length).padStart(2,'0')}`;
      requestAnimationFrame(positionCharacter);
      if(opened)announcement.textContent=`${options[index].textContent.trim()} — ${options[index].dataset.language}`;
    };
    const setOpen=(value,focus=false)=>{
      opened=value;device.classList.toggle('is-open',value);lid.style.removeProperty('--swivel');
      screen.inert=!value;unlock.tabIndex=value?-1:0;unlock.setAttribute('aria-hidden',String(value));
      help.textContent=value?help.dataset.open:help.dataset.closed;help.hidden=!value;
      if(value)show();
      if(focus&&root.classList.contains('ns-sk-keyboard-mode'))(value?trackball:unlock).focus({preventScroll:true});
    };
    const step=delta=>{if(!opened)setOpen(true);index=(index+delta+options.length)%options.length;show()};
    const enter=e=>{
      e?.preventDefault();if(leaving)return;leaving=true;
      try{sessionStorage.setItem('ns-sidekick-entered','1')}catch{}
      const url=new URL(location.href);url.searchParams.delete('landing');url.searchParams.set('enter','1');history.replaceState(null,'',url);
      root.classList.add('ns-sk-leaving');
      const finish=()=>{root.hidden=true;document.documentElement.classList.remove('ns-sk-active');blocked.forEach(([node,old])=>node.inert=old);const main=document.querySelector('#MainContent');if(main)main.focus({preventScroll:true});else if(previousFocus instanceof HTMLElement)previousFocus.focus({preventScroll:true});window.scrollTo({top:0,behavior:'instant'});document.dispatchEvent(new CustomEvent('northstar:entered'))};
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)finish();else setTimeout(finish,450);
    };
    root.querySelectorAll('[data-sk-enter],[data-sk-option]').forEach(link=>link.addEventListener('click',enter));
    unlock.addEventListener('click',()=>{if(suppressLidClick){suppressLidClick=false;return}setOpen(true,true)});
    root.addEventListener('pointerdown',()=>root.classList.remove('ns-sk-keyboard-mode'),{capture:true});
    lid.addEventListener('click',e=>{if(suppressLidClick){e.preventDefault();e.stopImmediatePropagation()}},{capture:true});
    lid.addEventListener('pointerdown',e=>{
      if(!e.isPrimary||e.button!==0)return;
      lidDrag={id:e.pointerId,y:e.clientY,progress:0,moved:false,wasOpen:opened,onLink:!!e.target.closest('[data-sk-option]')};
    });
    lid.addEventListener('pointermove',e=>{
      if(!lidDrag||lidDrag.id!==e.pointerId)return;
      const dy=lidDrag.wasOpen?e.clientY-lidDrag.y:lidDrag.y-e.clientY;
      if(Math.abs(dy)>5){lidDrag.moved=true;if(!lid.hasPointerCapture(e.pointerId))lid.setPointerCapture(e.pointerId)}
      if(!lidDrag.moved)return;
      lidDrag.progress=Math.max(0,Math.min(1,dy/(lid.offsetHeight*.8)));
      device.classList.add('is-dragging');
      lid.style.setProperty('--swivel',`${180*(lidDrag.wasOpen?1-lidDrag.progress:lidDrag.progress)}deg`);
    });
    const endLid=(e,cancel=false)=>{
      if(!lidDrag||lidDrag.id!==e.pointerId)return;
      const drag=lidDrag;lidDrag=null;device.classList.remove('is-dragging');
      if(lid.hasPointerCapture(e.pointerId))lid.releasePointerCapture(e.pointerId);
      suppressLidClick=drag.moved;
      let next=drag.wasOpen;
      if(!cancel){
        if(drag.moved){if(drag.progress>.2)next=!drag.wasOpen}
        else if(!drag.wasOpen)next=true;
        else if(!drag.onLink)next=false;
      }
      setOpen(next,!cancel);
      setTimeout(()=>suppressLidClick=false,100);
    };
    lid.addEventListener('pointerup',e=>endLid(e));lid.addEventListener('pointercancel',e=>endLid(e,true));lid.addEventListener('lostpointercapture',e=>endLid(e,true));
    trackball.addEventListener('pointerdown',e=>{
      if(!e.isPrimary||e.button!==0)return;
      ballDrag={id:e.pointerId,y:e.clientY,start:e.clientY,moved:false,carry:0};trackball.setPointerCapture(e.pointerId);
    });
    trackball.addEventListener('pointermove',e=>{
      if(!ballDrag||ballDrag.id!==e.pointerId)return;
      const delta=e.clientY-ballDrag.y;ballDrag.y=e.clientY;ballDrag.carry+=delta;
      if(Math.abs(e.clientY-ballDrag.start)>5)ballDrag.moved=true;
      const threshold=e.pointerType==='touch'?12:16;
      while(Math.abs(ballDrag.carry)>=threshold){const direction=Math.sign(ballDrag.carry);step(direction);ballDrag.carry-=direction*threshold}
      trackball.style.setProperty('--ball-y',`${30+Math.max(-18,Math.min(30,ballDrag.carry*2))}%`);
    });
    const endBall=e=>{
      if(!ballDrag||ballDrag.id!==e.pointerId)return;
      suppressBallClick=ballDrag.moved||e.type==='pointercancel';ballDrag=null;
      if(trackball.hasPointerCapture(e.pointerId))trackball.releasePointerCapture(e.pointerId);
      trackball.style.removeProperty('--ball-y');setTimeout(()=>suppressBallClick=false,100);
    };
    trackball.addEventListener('pointerup',endBall);trackball.addEventListener('pointercancel',endBall);trackball.addEventListener('lostpointercapture',endBall);
    trackball.addEventListener('click',e=>{if(suppressBallClick){e.preventDefault();suppressBallClick=false;return}if(!opened)setOpen(true,true);else enter(e)});
    trackball.addEventListener('wheel',e=>{e.preventDefault();if(performance.now()-wheelTime<110||Math.abs(e.deltaY)<1)return;wheelTime=performance.now();step(Math.sign(e.deltaY))},{passive:false});
    root.querySelector('[data-sk-prev]').addEventListener('click',()=>step(-1));
    root.querySelector('[data-sk-next]').addEventListener('click',()=>step(1));
    root.querySelector('[data-sk-home]').addEventListener('click',()=>{index=0;setOpen(true);show()});
    root.querySelector('[data-sk-close]').addEventListener('click',()=>setOpen(false,true));
    root.addEventListener('keydown',e=>{
      root.classList.add('ns-sk-keyboard-mode');
      if(e.key==='ArrowUp'||e.key==='ArrowDown'){e.preventDefault();step(e.key==='ArrowUp'?-1:1)}
      else if(e.key==='Escape'){e.preventDefault();if(opened)setOpen(false,true);else enter(e)}
      else if(e.key==='Tab'){
        const available=[...root.querySelectorAll('button,a[href]')].filter(el=>el.tabIndex>=0&&!el.closest('[inert]')&&el.getAttribute('aria-hidden')!=='true');
        const first=available[0],last=available[available.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
      }
    });
    new ResizeObserver(positionCharacter).observe(screen);
    show();root.focus({preventScroll:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
